import React, { ComponentType, PropsWithChildren, ReactNode } from "react";

import {
  IRouterContext,
  IAuthProvider,
  IDataMultipleContextProvider,
} from "@type";

export interface IRouterCommonProps<P> {
  useAuthProvider: () => IAuthProvider | undefined;
  AuthProvider?: React.FC<any>;
  dataProviders?: IDataMultipleContextProvider;
  LoadingComponent: React.FC<any>;
  outletWrapper?: ComponentType<PropsWithChildren>;
  routes: P[];
}

export const defaultProvider: IRouterContext = {
  useHistory: () => false,
  useLocation: () => false,
  useParams: () => ({}) as any,
  useBlocker: () => {},
  Prompt: () => null,
  Link: () => null,
};

export const RouterContext =
  React.createContext<IRouterContext>(defaultProvider);

export const RouterContextProvider: React.FC<
  PropsWithChildren<IRouterContext>
> = ({
  useHistory,
  useLocation,
  useParams,
  useBlocker,
  Prompt,
  Link,
  children,
}) => {
  return (
    <RouterContext.Provider
      value={{
        useHistory,
        useLocation,
        useParams,
        useBlocker,
        Prompt,
        Link,
      }}
    >
      {children}
    </RouterContext.Provider>
  );
};
